export enum InputPattern {
     namePattern = "^[a-zA-Z][a-zA-Z0-9éèêëçñøðåæœēčŭ.'_!,#^~\\- ]*$",
     descriptionPattern = "^[a-zA-Z][a-zA-Z0-9\-éèêëçñøðåæœēčŭ.'_!,#^~(\n) ]*$",
     errorMessage = "Valid characters include A-z, 0-9, [é,è,ê,ë,ç,ñ,ø,ð,å,æ,œ,ē,č,ŭ] and special characters [_,!,#,^,~,-,.,',]",
     descriptionErrorMessage = "Valid characters include A-z, 0-9, [é,è,ê,ë,ç,ñ,ø,ð,å,æ,œ,ē,č,ŭ] and special characters [_,!,#,^,~,-,.,',(,)]",
     firstCharacterErrorMessage = "First character should be A-Z,a-z.",
     fnameLnameCharErrorMessage = "First Name and Last Name should start with A-Z,a-z.",
     firstCharSmallErrorMessage = "First character should be a-z.",
     cnamePattern = '^[a-z]*([-]*[a-z][a-z0-9]*)+$',
     numberPattern = '^[0-9]+$',
     numericErrorMessage =  "Please enter a valid numeric value.",
}